export const SWAP_ROWS = {
  headerOptions: {
    Header: 'Swap Rows',
  },
  show: false,
  swapRowDown: () => {},
  swapRowUp: () => {},
};
